// extracted by mini-css-extract-plugin
module.exports = {"board":"chessboard_board__12nW8","square":"chessboard_square__20UgM"};